module.exports = "/virtual-football-league/img/games-table-odds-disabled.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/games-table-odds-disabled.png
// module id = 180
// module chunks = 4